/*

? Why a listing delete was refused, in the website's three languages (1 Nov 2026). Browser-safe: no server imports.

The delete routes (app bbm-android/listings/delete-property, web properties/edit-property/delete-property and
delete-ofb-property) refuse a listing that has a broadcast in review, answering `payload.code: "broadcast_in_review"`
(lib/broadcasts/broadcastCooldown.ts `hasBroadcastInReview`). The website's delete dialogs show the text below; the
apps keep their own copy of it.

*/

/** The refusal code the delete routes answer while the listing has a broadcast in review. */
export const BROADCAST_IN_REVIEW_DELETE_CODE = "broadcast_in_review";

/** What a website delete dialog says when the delete didn't go through: [code] is the route's `payload.code`. */
export function listingDeleteRefusalText(code: string, locale: string | undefined): string {
	if (code === BROADCAST_IN_REVIEW_DELETE_CODE) {
		return locale === "ar-AE"
			? "لهذا الإعلان بث قيد المراجعة، لذا لا يمكن حذفه حتى يتم إرسال البث."
			: locale === "kn-IN"
				? "ಈ ಲಿಸ್ಟಿಂಗ್‌ನ ಬ್ರಾಡ್‌ಕಾಸ್ಟ್ ಪರಿಶೀಲನೆಯಲ್ಲಿದೆ, ಆದ್ದರಿಂದ ಬ್ರಾಡ್‌ಕಾಸ್ಟ್ ಕಳುಹಿಸುವವರೆಗೆ ಇದನ್ನು ಅಳಿಸಲು ಸಾಧ್ಯವಿಲ್ಲ."
				: "This listing has a broadcast in review, so it can't be deleted until the broadcast is sent.";
	}
	return locale === "ar-AE"
		? "حدث خطأ ما. يرجى المحاولة مرة أخرى."
		: locale === "kn-IN"
			? "ಏನೋ ತಪ್ಪಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ."
			: "Something went wrong. Please try again.";
}
